import Stack from '@mui/material/Stack';
import TimeSiteSwitch from 'src/components/settings/partials/TimeSiteSwitch';
import Index from 'src/components/settings/time/Index';

const Time = () => {
  return (
    <>
      <TimeSiteSwitch page="mastertime"/>
      <Stack direction={'row'} spacing={'20px'} width={'auto'}>
        <Index />
      </Stack>
    </>
  );
};

export default Time;
